import { JsonCodeBlock } from '@optools/components/json-code-block';
import { Button } from '@optools/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@optools/components/ui/dialog';
import { AuditView } from '@optools/services/operator-gateway/types/generated/graphql';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { Braces } from 'lucide-react';

import { AuditTableDialogType } from '../../schemas/audits';

export interface AuditTableEventDataProps {
  auditId: number;
  eventData: AuditView['eventData'];
  operation: string;
}

export function AuditTableEventData({ auditId, eventData, operation }: AuditTableEventDataProps) {
  const params = useSearch({ from: '/_auth/audit/audits' });
  const navigate = useNavigate();

  const handleOpenChange = (open: boolean) => {
    navigate({
      search: (current) => ({
        ...current,
        auditId: open ? auditId : undefined,
        dialog: open ? AuditTableDialogType.EventData : undefined,
      }),
      to: '/audit/audits',
    });
  };

  if (!eventData) return null;

  const open = params.auditId === auditId && params.dialog === AuditTableDialogType.EventData;

  return (
    <Dialog defaultOpen={open} open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button className="text-xs" size="sm" variant="outline">
          <Braces className="size-3" />
          Event Data
        </Button>
      </DialogTrigger>
      <DialogContent className="grid max-h-full max-w-max! grid-rows-[auto_1fr] sm:max-h-9/10 sm:min-w-2xl">
        <DialogHeader>
          <DialogTitle>Event Data</DialogTitle>
          <DialogDescription>{operation}</DialogDescription>
        </DialogHeader>
        <JsonCodeBlock json={eventData} />
      </DialogContent>
    </Dialog>
  );
}
